import FpuiInputEnvironmentVariables from './FpuiInputEnvironmentVariables.vue'
export default FpuiInputEnvironmentVariables
